import React from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const handlePageClick = (event) => {
    onPageChange(event.selected + 1);
  };

  const handleFirstPage = () => {
    onPageChange(1);
  };

  const handleLastPage = () => {
    onPageChange(totalPages);
  };

  const { pagination } = useSelector((state) => state.users);

  return (
    <div className="flex items-center justify-center space-x-2">
      {/* First page button */}
      <button
        onClick={handleFirstPage}
        disabled={currentPage === 1}
        className={`px-3 py-1 cursor-pointer hover:bg-gray-200 rounded-md transition-colors duration-200 ${
          currentPage === 1 ? "opacity-50 cursor-not-allowed hover:bg-transparent" : ""
        }`}
        title="İlk sayfa"
      >
        &laquo;
      </button>
      
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        previousLabel="<"
        containerClassName="flex items-center justify-center space-x-2"
        pageClassName="rounded-md cursor-pointer text-grayy hover:bg-gray-200 transition-colors duration-200 flex items-center justify-center min-w-[40px]"
        pageLinkClassName="w-full h-full px-4 py-2 flex items-center justify-center"
        activeClassName="bg-black text-white hover:bg-black hover:!bg-black"
        previousClassName="px-3 py-1 cursor-pointer hover:bg-gray-200 rounded-md transition-colors duration-200"
        nextClassName="px-3 py-1 cursor-pointer hover:bg-gray-200 rounded-md transition-colors duration-200"
        disabledClassName="opacity-50 cursor-not-allowed hover:bg-transparent"
        breakClassName="px-2"
        pageCount={totalPages}
        forcePage={currentPage - 1}
        marginPagesDisplayed={0}
      />

      {/* Last page button */}
      <button
        onClick={handleLastPage}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 cursor-pointer hover:bg-gray-200 rounded-md transition-colors duration-200 ${
          currentPage === totalPages ? "opacity-50 cursor-not-allowed hover:bg-transparent" : ""
        }`}
        title="Son sayfa"
      >
        &raquo;
      </button>
    </div>
  );
};

export default React.memo(Pagination);
